import { IconButton, TableBody, TableCell, TableRow } from "@mui/material";
import { commonTableStyles as styles } from "./tableStyles";
import { Delete } from "@mui/icons-material";
import BlockIcon from "@mui/icons-material/Block";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { Users } from "utils/modals";
import Loader from "components/loader";
import { Box } from "@mui/system";
type Props = {
  userTableFunctions: any;
};
const UserTableBody: React.FC<Props> = ({ userTableFunctions }) => {
  const userState: Users = useSelector(
    (state: RootState) => state.usersInfo.users
  );
  const { result, isLoading, page: pagination } = userState;
  const { page, limit } = pagination;
  if (isLoading) {
    return (
      <TableCell rowSpan={5} colSpan={7} sx={{}}>
        <Loader />
      </TableCell>
    );
  }
  return (
    <TableBody>
      {result && result.length > 0 ? (
        result.map((res: any, i: number) => {
          const serialNo = (page - 1) * limit + (i + 1);
          const userName = res.firstName + " " + res.lastName || "N/A";
          const gender = res.gender === "0" ? "Sister" : "Brother";
          return (
            <TableRow sx={{ ...styles.row }} key={i}>
              <TableCell>{serialNo}</TableCell>
              <TableCell>{userName}</TableCell>
              <TableCell>{res.email || "N/A"}</TableCell>
              <TableCell>{res.zipcode || "N/A"}</TableCell>
              <TableCell>{gender || "N/A"}</TableCell>
              <TableCell>
                {moment(res.createdAt).format("LL") || "N/A"}
              </TableCell>
              <TableCell>
                <Box display={"flex"} gap={1}>
                  <IconButton
                    size="small"
                    onClick={() =>
                      userTableFunctions.modalSoftDeleteMode(res.id)
                    }
                    sx={{
                      ...styles.error,
                      borderRadius: "4px",
                    }}
                  >
                    <BlockIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() =>
                      userTableFunctions.modalHardDeleteMode(res.id)
                    }
                    sx={{
                      ...styles.error,
                      borderRadius: "4px",
                    }}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </Box>
              </TableCell>
            </TableRow>
          );
        })
      ) : (
        <TableRow>
          <TableCell
            colSpan={7}
            rowSpan={3}
            sx={{
              fontWeight: 600,
              fontSize: "1.5rem",
              lineHeight: "22px",
              textAlign: "center",
            }}
          >
            {"No Data Found"}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};

export default UserTableBody;
